import { render } from "./SpacesGroupDesc.vue?vue&type=template&id=bdbe3ac6&scoped=true&ts=true"
import script from "./SpacesGroupDesc.vue?vue&type=script&lang=ts"
export * from "./SpacesGroupDesc.vue?vue&type=script&lang=ts"

import "./SpacesGroupDesc.vue?vue&type=style&index=0&id=bdbe3ac6&lang=sass&scoped=true"

import exportComponent from "/home/casedrive/releases/front/108/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdbe3ac6"]])

export default __exports__